export default  {
  '展位号':'Booth Number',
  '商品信息':'Commodity Information',
  '规格':'Spec',
  '单价':'Unit Price',
  '数量':'Number',
  '小计':'Subtotal',
  '操作':'operation',
  '描述':'describe',
  '暂无描述':'No description yet',
  '暂无规格':'No specifications',
  '含押金':'foregift',
  '删除':'delete',
  '费用合计':'Total cost',
  '展位费用项':'Booth Expenses',
  '已选择':'Selected',
  '个展位':'Booth',
  '展位':'Booth',
  '首页':'home page',
  '租赁商品列表':'List of Leased Goods',
  '租赁清单':'Lease List',
  '结算':'Settlement',
  '返回':'back',
  '租赁服务':'Rental services'
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/SettlementList.js